import { getLocale } from 'services/LocalizationService';
import DMAStorageService from 'services/DMAStorageService';

const getAutoplayRegistryFromLocalStorage = () => {
    const registryName = `continuous_play_${CBS.Registry.user.profile_id}`;
    const registryValue = localStorage.getItem(registryName);
    return registryValue == 'true' || !registryValue ? true : false;
};

export const getContinuousPlayEnabledStatus = (continousPlayFlag) => {
    return getAutoplayRegistryFromLocalStorage() && continousPlayFlag == 1;
};

export const getContinuousPlayEnabledTrackingStatus = () => {
    const autoPlayEnabled = getAutoplayRegistryFromLocalStorage();
    return autoPlayEnabled == true ? '1' : '0';
};

export const getLiveEndcardDma = () => {
    const DMAStorage = new DMAStorageService();
    const dmaInfo = DMAStorage.getStorageDMA();
    return dmaInfo[0].dma ?? 0;
};

export const formatEpisodesRemaining = (CPEpisodesRemainingEnabled, recommendations) => {
    let episodesRemaining = {
        enabled: false,
    };
    if (CPEpisodesRemainingEnabled && recommendations?.[0]?.episodesRemainingInfo?.poEditorKey) {
        episodesRemaining.enabled = true;
        const ctaKey = recommendations?.[0]?.episodesRemainingInfo?.poEditorKey;
        let ctaText = '';
        if (ctaKey) {
            ctaText = getLocale(ctaKey);
        }
        episodesRemaining.params = {
            episodesRemainingText: ctaText,
            poEditorKey: ctaKey ?? '',
        };
        if (recommendations?.[0]?.episodesRemainingInfo?.episodesRemaining) {
            episodesRemaining.params['episodesRemaining'] =
                recommendations?.[0]?.episodesRemainingInfo?.episodesRemaining;
        }
    }
    return episodesRemaining;
};
